import { useEffect, useState } from "react";
import ContactButton from "./ContactButton";
import BureauAboutIcon from "./Icons/BureauAboutIcon";

const BureauHero = () => {
  const [startYourAnimation, setStartYourAnimation] = useState<boolean>(false);
  const [startGatewayAnimation, setStartGatewayAnimation] = useState<boolean>(false);
  const [startToAnimation, setStartToAnimation] = useState<boolean>(false);
  const [startSuccessAnimation, setStartSuccessAnimation] = useState<boolean>(false);

  useEffect(() => {
    const startYourAnimationTimer = setTimeout(() => {
      setStartYourAnimation(true);
    }, 50);
    const startGatewayAnimationTimer = setTimeout(() => {
      setStartGatewayAnimation(true);
    }, 1050);
    const startToAnimationTimer = setTimeout(() => {
      setStartToAnimation(true);
    }, 2050);
    const startSuccessAnimationTimer = setTimeout(() => {
      setStartSuccessAnimation(true);
    }, 3050);

    return () => {
      clearTimeout(startYourAnimationTimer);
      clearTimeout(startGatewayAnimationTimer);
      clearTimeout(startToAnimationTimer);
      clearTimeout(startSuccessAnimationTimer);
    };
  }, []);
  return (
    <section className="relative flex-1 min-h-[calc(100dvh-78px)] max-h-[calc(100dvh-78px)] bg-black md:px-15 xl:px-30 auto-rows-auto xl:grid-rows-3 text-white grid grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-12 gap-4 md:gap-6 xl:gap-8 xl:gap-y-0 items-center">
      <h1 className="col-span-full xl:col-span-10 text-xl xl:text-[64px] xl:leading-[1.2] font-xExpandedBold px-6 xl:px-0">
        <span
          className={`transition-opacity ease-in duration-500  ${
            startYourAnimation ? " opacity-100" : "opacity-0"
          }`}
        >
          YOUR
        </span>{" "}
        <span
          className={`transition-opacity ease-in duration-500  ${
            startGatewayAnimation ? " opacity-100" : "opacity-0"
          } `}
        >
          GATEWAY
        </span>{" "}
        <span
          className={`transition-all ease-liner duration-500  ${
            startToAnimation ? "opacity-100" : "opacity-0"
          } `}
        >
          TO
        </span>{" "}
        <span
          className={`transition-all ease-liner duration-500 text-cultiv-yellow  ${
            startSuccessAnimation ? "opacity-100" : "opacity-0"
          } `}
        >
          SUCCESS
        </span>
      </h1>
      <div className="lg:col-start-3 col-span-full xl:col-span-8 grid grid-cols-4 xl:col-start-5 xl:grid-cols-8 xl:gap-8 row-start-2 w-full self-start logo z-30 relative max-h-min">
        <div className="col-span-2 xl:col-span-4 col-start-2 lg:px-13 z-30">
          <img
            src="/images/bureau/bureauLogo.svg"
            alt="Cultiv Studio Logo"
            className=" w-full bg-black xl:max-w-[274px]"
            width={274}
            height={64}
          />
        </div>

        {/**
         * Horizontal Line below studio logo
         */}
        <div className="absolute scale-y-50 col-start-2 xl:col-start-3 3xl:col-start-2 w-full md:w-[calc(100%+60px)] xl:w-[calc(100%+120px)] bottom-0 -z-20">
          <span className=" block h-0.5 bg-white w-full" />
        </div>
      </div>

      <BureauAboutIcon />

      <div className="px-6 xl:px-0 xl:row-start-2 xl:pt-32 h-full col-span-full xl:col-span-5 xl:col-start-1 w-full grid grid-cols-subgrid gap-y-10 xl:gap-y-8 auto-rows-min">
        <h3 className="font-Light text-xl xl:text-2xl 3xl:text-3xl col-span-3 xl:col-span-full">
          Expanding your business to Egypt?
        </h3>
        <p className="font-Light xl:text-lg 3xl:text-xl pr-20 xl:pr-6 col-span-full">
          Cultiv Bureau is your one-stop shop for a seamless soft-landing. We bridge the gap between
          your global aspirations and the immense potential of the Egyptian market.
        </p>
        <ContactButton
          className="col-span-3 xl:col-span-2"
          bgHoverColor="hover:bg-cultiv-yellow"
          borderHoverColor="hover:border-cultiv-yellow"
          textHoverColor="hover:text-black"
          text="Learn More"
          arrowHoverColor="group-hover:stroke-black"
          path="https://bureau.cultiv.llc/contact"
        />
      </div>
      {/**
       * Horizontal Line above studio logo
       */}
      <div className="absolute scale-y-50 col-start-1 md:col-start-auto col-span-2 md:col-end-3 lg:col-end-4 xl:col-end-6 row-start-2 row-end-2 self-start xl:self-auto xl:row-start-1 xl:row-end-2 w-full xl:-bottom-0.5">
        <span className="block h-0.5 bg-white w-full self-start" />
      </div>

      <div className="absolute scale-y-50 xl:row-end-4 w-full -bottom-[2px]">
        <span className="block h-0.5 bg-white w-full self-start" />
      </div>

      {/* Vertical lines */}
      <div className="absolute left-[13.4%] xl:left-[100px] 2xl:left-[110px] scale-x-50 col-start-2 xl:col-start-5 top-0 row-start-2 xl:row-end-4 h-full">
        <span className="hidden xl:block w-0.5 bg-white h-full " />
      </div>
    </section>
  );
};

export default BureauHero;
